import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import lang from '@/lang'

export default class GuaranteeType {
  constructor(type, code, name, tableName, selectFormat, selectData) {
    this.type = type // 数据类型
    this.code = code // 数据code，用于no、key等
    this.name = name // 数据code，用于no、key等
    this.tableName = tableName // 标签页名称属于国际化
    this.selectFormat = selectFormat // 下拉选项，输入框。"select\input\file"
    this.selectData = selectData // 下拉选项数据源，如果selectFormat为select，就会有值
  }
}

// 委托单位
export const CUSTOMER = new GuaranteeType(1, 'customer', '委托单位',
  lang.t('CargoMsg.Cargo_AuthorizedClient'), 'select', TYPE_NAMES.basic_data_Company)

// 业务类型
export const BUSINESS_TYPE = new GuaranteeType(2, 'businessType', '业务类型',
  lang.t('CargoMsg.Cargo_BusinessType'), 'select', '')

// 货物种类
export const CARGO_TYPE = new GuaranteeType(3, 'cargoType', '货物种类',
  lang.t('CargoMsg.Cargo_TypeOfGoods'), 'select', TYPE_NAMES.basic_data_CargoType)

// 整拼类型
export const CONTAINER_TYPE = new GuaranteeType(4, 'containerType', '整拼类型',
  lang.t('CargoMsg.Cargo_FLCLType'), 'select', TYPE_NAMES.basic_data_CargoType)

// 起运港（海港）
export const SEA_POL = new GuaranteeType(5, 'seaPol', '起运港（海港）',
  lang.t('CargoMsg.Cargo_PortOfLoading'), 'select', TYPE_NAMES.basic_data_Seaport)

// 目的港（海港）
export const SEA_POD = new GuaranteeType(6, 'seaPod', '目的港（海港）',
  lang.t('CargoMsg.Cargo_DestinationPort'), 'select', TYPE_NAMES.basic_data_Seaport)

// 发货人
export const SHIPPER = new GuaranteeType(7, 'shipper', '发货人',
  lang.t('CargoMsg.Cargo_Shipper'), 'select', TYPE_NAMES.basic_data_Company)

// 收货人
export const CONSIGNEE = new GuaranteeType(8, 'consignee', '收货人',
  lang.t('CargoMsg.Cargo_Consignee'), 'select', TYPE_NAMES.basic_data_Company)

// 承运人
export const CARRIER = new GuaranteeType(9, 'carrier', '承运人',
  lang.t('CargoMsg.Cargo_Carrier'), 'select', TYPE_NAMES.basic_data_Company)

// 订舱代理
export const BOOKING_AGENT = new GuaranteeType(10, 'bookingAgent', '订舱代理',
  lang.t('CargoMsg.Cargo_BookingAgent'), 'select', TYPE_NAMES.basic_data_Company)

// 航线/区域
export const ROUTE_AREA = new GuaranteeType(11, 'routeArea', '航线/区域',
  lang.t('CargoMsg.Cargo_RouteArea'), 'select', '')

// 目的港代理
export const DESTINATION_AGENT = new GuaranteeType(12, 'destinationAgent', '目的港代理',
  lang.t('CargoMsg.Cargo_DestinationAgent'), 'select', TYPE_NAMES.basic_data_Company)

// 指定货代理
export const NOMINATED_AGENT = new GuaranteeType(13, 'nominatedAgent', '指定货代理',
  lang.t('CargoMsg.Cargo_NominatedAgent'), 'select', TYPE_NAMES.basic_data_Company)

// 可用分公司
export const AVAILABLE_BRANCH = new GuaranteeType(14, 'availableBranch', '可用分公司',
  lang.t('CargoMsg.Cargo_AvailableBranch'), 'select', TYPE_NAMES.basic_data_Office)

// 文件历史
export const FILE_HISTORY = new GuaranteeType(15, 'fileHistory', '文件历史',
  lang.t('CargoMsg.Cargo_FileHistory'), 'select', '')

export const GUARANTEE_TYPES = [
  CUSTOMER,
  BUSINESS_TYPE,
  CARGO_TYPE,
  CONTAINER_TYPE,
  SEA_POL,
  SEA_POD,
  SHIPPER,
  CONSIGNEE,
  CARRIER,
  BOOKING_AGENT,
  ROUTE_AREA,
  DESTINATION_AGENT,
  NOMINATED_AGENT,
  AVAILABLE_BRANCH,
  FILE_HISTORY
]

/**
 * return null:没找到.
 */
export function getTypeByGroupName(code) {
  let type = null
  for (const obj of GUARANTEE_TYPES) {
    if (obj.code === code) {
      type = obj.type
      break
    }
  }
  return type
}

